import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    form: {
        // Prevent text from running behind the footer
        paddingBottom: 60,

        // And the Header
        [theme.fn.largerThan("xs")]: {
            paddingTop: 60,
        },

        // remove padding for modals
        ".mantine-Modal-body &": {
            paddingBottom: 0,
        },
    },
}))
